import {Component, Input, OnInit} from '@angular/core';
export interface IRecomendationItem {
  index: string;
  text: string;
}
@Component({
  selector: 'app-recommendations-item',
  templateUrl: './recommendations-item.component.html',
  styleUrls: ['./recommendations-item.component.scss']
})
export class RecommendationsItemComponent implements OnInit {

  @Input() data: IRecomendationItem;
  constructor() { }

  ngOnInit(): void {
  }

}
